import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inner: [
                {
                    id: 1,
                    icon: 'fa fa-check-square',
                    text: 'Yüksek Kalitede'
                },
                {
                    id: 2,
                    icon: 'fa fa-check-square',
                    text: 'Güvenli'
                },
                {
                    id: 3,
                    icon: 'fa fa-check-square',
                    text: 'Tam Zamanında'
                },
                {
                    id: 4,
                    icon: 'fa fa-check-square',
                    text: 'Güçlü Ekibimiz'
                },
            ]
        }
    }

    render() {
        return (
            <div className="row-about">

                <div className="container-fluid">


                    <div className="row equalize sm-equalize-auto">





                        <div className="col-md-6 bg-light-grey" >
                            <div className="themesflat-spacer clearfix" data-desktop={64} data-mobile={60} data-smobile={60} />
                            <div className="themesflat-content-box clearfix" data-margin="0 20% 0 20%" data-mobilemargin="0 0 0 4.5%">
                                  <div className="themesflat-spacer clearfix" data-desktop={26} data-mobile={35} data-smobile={35} />
                                <h3 className="heading"> 1990 yılında başlamış olduğumuz bu serüvende alt yapı ve üst yapı projeleri ile inşaat alanında faaliyet göstermekteyiz. Taahhüt işleri, konut,ticari yapılar ve kentsel dönüşüm projelerimiz ile hedeflerimizi gerçekleştirmeye devam ediyoruz. Mühendislik tecrübemiz ile kalite ve sağlamlıktan ödün vermeden güvenli yaşam alanları inşa ediyoruz.</h3>
                            </div>


                        </div>





                        <div className="col-md-6 bg-light-grey">

                            <div className="themesflat-spacer clearfix" data-desktop={64} data-mobile={60} data-smobile={60} />
                            <div className="themesflat-content-box clearfix" data-margin="0 25% 0 4.5%" data-mobilemargin="0 0 0 4.5%">
                                <div className="themesflat-headings style-1 clearfix">
                                    <h2 className="heading">TACAR MUHENDISLIK</h2>
                                    <div className="sep has-width w80 accent-bg margin-top-11 clearfix" />
                                    <p className="sub-heading margin-top-30">Istanbulun bir çok bölgesinde tamamladığımız projeler ile</p>
                                </div>
                                <div className="themesflat-spacer clearfix" data-desktop={26} data-mobile={35} data-smobile={35} />
                                <div className="content-list">
                                    <div className="themesflat-list has-icon style-1 icon-left clearfix">
                                        <div className="inner">
                                            {
                                                this.state.inner.map(data => (
                                                    <span className="item" key={data.id}>
                                                        <span className="icon"><i className={data.icon} /></span>
                                                        <span className="text">{data.text}</span>
                                                    </span>
                                                ))
                                            }
                                        </div>
                                        <div className="themesflat-headings style-1 clearfix">


                                            <p className="sub-heading margin-top-30">ile tamamladığımız projeler ile sizinle birlikte çalışmaktan hala heyecan duyuyoruz</p>
                                        </div>


                                    </div>


                                </div>
                                <div className="themesflat-spacer clearfix" data-desktop={42} data-mobile={35} data-smobile={35} />
                                <div className="elm-button">
                                    <a href="/contact-01" rel="noopener noreferrer" className="themesflat-button bg-white">
                                        İLETİŞİM
                                    </a>
                                </div>
                            </div>
                            <div className="themesflat-spacer clearfix" data-desktop={75} data-mobile={60} data-smobile={60} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default About;